/**
 * UserNotifications handles inbound user specific notification
 * coming form the server.  Displays a popup if the notification
 * meets certain parameters
 */

import { store } from '@/store'
import UserNotification from '@/types/UserNotification.interface'

export default {
    onUserNotificationReceived(notification: UserNotification) {
        store.getters.appDebug && console.log('USER NOTIFICATIONS: onUserNotificationReceived')

        //  If a user does NOT exist, do nothing
        if (!store.getters.user) return

        //  Get the current tenant
        const tenant = store.getters.tenant

        //  Check if we should process the notification (ie, we only want to handle notification in the current tenant context)
        const shouldProcess = tenant && notification.tenant_id === tenant.id

        //  If we should NOT process the notification, do nothing
        if (!shouldProcess) return
        
        //  If csvType is groupExport, pop export dialog
        if (notification.csvType == 'groupExport') return this.popExportDialog(notification)

        //  Pop the in-app notification
        store.commit('notificationPopupOpen', notification)
    },
    popExportDialog(notification: UserNotification) {
        //  Pop a popup informing what happened
        store.dispatch('dialogOpen', {
            type: 'CONFIRM',
            title: 'CSV Export is ready',
            text: `${notification.text} Would you like to download the .CSV?`,
            icon: 'mdi-information',
            color: 'primary',
            callback: (result) => {
                //  If the user selected 'NO' in the dialog, do nothing
                if (!result) return

                //  Else, run the executable
                this.downloadCsv(notification)
            }
        })
    },
    //  This is the handler for a notification with 'exec = downloadCsv'
    async downloadCsv(n: UserNotification) {
        //  Check that the notification action is 'downloadCsv;
        const isDownloadCsv = n.action.exec === 'downloadCsv'

        //  If the notification action is NOT 'downloadCsv' throw error
        if (!isDownloadCsv) throw 'Notification does not contain an executable action: downloadCsv'

        //  Else, get the csv down link from the notification action
        const link = n.action.params

        //  Download the csv
        const success = await store.dispatch('csvDownload', link)

        //  If the download was not successful, pop failure message
        if (!success) {
            return store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'CSV Download Error',
                text: `There was a problem while downloading the CSV. This is often due to an expired link. Please try your CSV export again.`
            })
        }
    },
}
